
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/antara/api/pegs",
      function () {
        return require("private-next-pages/docs/antara/api/pegs/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/antara/api/pegs"])
      });
    }
  